import { render, staticRenderFns } from "./ConsultingAgreementTemplate.vue?vue&type=template&id=2dc97184&scoped=true&"
import script from "./ConsultingAgreementTemplate.vue?vue&type=script&lang=ts&"
export * from "./ConsultingAgreementTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./ConsultingAgreementTemplate.vue?vue&type=style&index=0&id=2dc97184&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc97184",
  null
  
)

export default component.exports